module.exports = __webpack_public_path__ + "img/home-slider-4.8dc6395a.jpeg";